import { type FormEvent, memo, useState } from "react";
import "Components/ConfigLayout/Camera/CodecSettings/CodecSettings.less";
import { Card, Select, SettingsLayout, Tabs } from "@clintonelec/react-storybook";
import { useAppDispatch, useAppSelector } from "Data/Redux/Store";
import { selectCodec, setCodecAction } from "Data/Redux/Slices/Settings/Camera/Codec";
import FourthTabContent from "Components/ConfigLayout/Camera/CodecSettings/TabContents/FourthTabContent";
import TabContent from "Components/ConfigLayout/Camera/CodecSettings/TabContents/TabContent";
import { videoFormatOptions } from "Data/Objects/CodecSettingsOptions";
import { isEqual } from "lodash";
import { produce } from "immer";
import ActionButtons from "Components/ConfigLayout/ActionButtons";

function CodecSettings() {
	const dispatch = useAppDispatch();
	const codecSettings = useAppSelector(selectCodec);
	const codecSettingsState = useState(codecSettings);
	const [ localCodecSettings, setLocalCodecSettings ] = codecSettingsState;
	const setCodecSettings = () => dispatch(setCodecAction(localCodecSettings));
	const disabled = isEqual(localCodecSettings, codecSettings);

	const handleReset = (event: FormEvent<HTMLFormElement>) => {
		event.preventDefault();

		setLocalCodecSettings(codecSettings);
	};

	const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
		event.preventDefault();

		setCodecSettings();
	};

	const handleVideoFormatSelect = (newVideoFormat: string | null) => {
		if (!newVideoFormat) {
			return;
		}

		setLocalCodecSettings(produce(localCodecSettings, draft => {
			draft.videoFormat = +newVideoFormat;
		}));
	};

	const createContents = (index: number) => {
		if (index === 3) {
			return <FourthTabContent
				codecSettingsState={ codecSettingsState }
				streamIndex={ index }
			/>;
		}

		return <TabContent
			codecSettingsState={ codecSettingsState }
			streamIndex={ index }
		/>;
	};

	const panes = [
		{
			title: "Main Stream",
			content: createContents(0)
		},
		{
			title: "Second Stream",
			content: createContents(1)
		},
		{
			title: "Third Stream",
			content: createContents(2)
		},
		{
			title: "Fourth Stream",
			content: createContents(3)
		}
	];

	return (
		<SettingsLayout.Form
			className="codec-settings"
			onReset={ handleReset }
			onSubmit={ handleSubmit }
		>
			<SettingsLayout.ScrollableContainer>
				<Card size="small" title="Codec">
					<Tabs panes={ panes } />
				</Card>
				<Card size="small" title="Camera Properties">
					<div className="form-row">
						<label>Video Format</label>
						<Select
							allowClear={ false }
							className="form-select"
							onSelect={ handleVideoFormatSelect }
							options={ videoFormatOptions }
							value={ localCodecSettings.videoFormat }
						/>
					</div>
				</Card>
			</SettingsLayout.ScrollableContainer>
			<ActionButtons disabled={ disabled } />
		</SettingsLayout.Form>
	);
}

export default memo(CodecSettings);
